<select class="form-select"
        [formControl]="selectLocation"
        [attr.disabled]="isEnabled ? null : true">
  @for (l of locations; track l) {
  <option [ngValue]="l"
          [selected]="l.id === location?.id">{{ l.displayName }}</option>
  }
</select>